(() => {
  const FORM_FLAG = "condensedEnhanced";
  const MIDPOINT_FLAG = "condensedMidpointBound";

  const parseCartResponse = async response => {
    const contentType = response.headers.get("content-type") || "";
    const bodyText = await response.text();

    if (!response.ok) {
      const error = new Error(`/cart/add.js failed with status ${response.status}`);
      error.status = response.status;
      error.bodyText = bodyText;
      throw error;
    }

    if (!contentType.includes("application/json")) {
      const error = new Error("/cart/add.js returned non-JSON content");
      error.status = response.status;
      error.bodyText = bodyText;
      throw error;
    }

    return bodyText ? JSON.parse(bodyText) : {};
  };

  const enhanceSection = root => {
    const section =
      root instanceof Element
        ? root.querySelector("#condensed-options")
        : document.getElementById("condensed-options");
    if (!section) return;

    const forms = section.querySelectorAll("[data-condensed-form]");
    forms.forEach(form => {
      if (form.dataset[FORM_FLAG] === "true") return;

      form.dataset[FORM_FLAG] = "true";
      form.addEventListener("submit", event => {
        if (!window.fetch) return;
        event.preventDefault();

        const idInput = form.querySelector('input[name="id"]');
        const variantId = idInput ? idInput.value : "";
        if (!variantId) {
          form.submit();
          return;
        }

        const button = form.querySelector("button");
        if (button) button.disabled = true;

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        })
          .then(parseCartResponse)
          .then(() => {
            document.dispatchEvent(
              new CustomEvent("cart:updated", { detail: { source: "condensed-options" } })
            );
          })
          .catch(() => {
            form.submit();
          })
          .finally(() => {
            if (button) button.disabled = false;
          });
      });
    });
  };

  const run = root => enhanceSection(root || document);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => run());
  } else {
    run();
  }

  document.addEventListener("shopify:section:load", event => {
    if (!event || !event.target) return;
    run(event.target);
  });
})();
